import React from 'react';
import dynamic from 'next/dynamic';
import { useT } from '@transifex/react';
import { IntlShape } from 'react-intl/src/types';
import { useFeatureFlag } from '@raisin/cp-utils';
import { buildTabs, selectDefaultTab } from './tabsConfigUtils';
import { DBSProduct, productTypes } from 'types';
import { useThemeVersion } from '@raisin/components-lib';
import {
  onSelectTab,
  onOfferRowTabClickHandler,
  onLoadMoreClickHandler,
  onTermFilterChangeHandler,
  onCountryFilterChangeHandler,
  onInvestmentAmountInputChangeHandler,
  onColumnSortChangeHandler,
  onCountryRatingChangeHandler,
  onCTAClickHandler,
} from '../../eventsTracking';
import * as S from './styles';
import RebrandedOffersTableStyles from './RebrandedOffersTableStyles';

interface Props {
  loading: boolean;
  offers: Array<Object>;
  onInvestNowClick: (offer: DBSProduct, isLoggedIn: boolean) => void;
  onMobileInvestNowClick: (offer: DBSProduct, isLoggedIn: boolean) => void;
  intl: IntlShape;
  locale: string;
  config: any;
  ACTIVATED_TABS: productTypes[];
  DEFAULT_TAB: productTypes;
  isLoggedIn: boolean;
  isWrappedByLayoutContainer?: boolean;
  OFFER_TABLE_EVENTS: any;
}

const Tabs: any = dynamic(() => import('@raisin/cp-legacy-ui-lib').then((mod) => mod.Tabs), {
  ssr: false,
});

const ProductsTabs: React.FC<Props> = ({
  config,
  loading,
  offers,
  ACTIVATED_TABS,
  DEFAULT_TAB,
  onInvestNowClick,
  onMobileInvestNowClick,
  locale,
  intl,
  isLoggedIn,
  isWrappedByLayoutContainer,
  OFFER_TABLE_EVENTS,
}) => {
  const themeVersion = useThemeVersion();
  const t = useT();
  const { variation } = useFeatureFlag();
  const isShuffleProductsFeatureFlagOn = variation?.('b2cOTShuffleProducts', false);
  const useRedesignedOfferTable = variation?.('useRedesignedOfferTable', false);

  const rebrandedClass = themeVersion === 'v2' && useRedesignedOfferTable ? 'rebranded' : '';

  return (
    <S.WrapperDiv
      isWrappedByLayoutContainer={isWrappedByLayoutContainer}
      className={rebrandedClass}
    >
      {Boolean(rebrandedClass) && <RebrandedOffersTableStyles />}
      <Tabs
        centered
        showTabList={ACTIVATED_TABS.length > 1}
        selectedTab={selectDefaultTab(ACTIVATED_TABS, DEFAULT_TAB)}
        onSelect={onSelectTab(OFFER_TABLE_EVENTS)}
        tabs={buildTabs({
          loading,
          offers,
          isRebranded: Boolean(rebrandedClass),
          onInvestNowClick,
          onMobileInvestNowClick,
          config,
          locale,
          intl,
          t,
          ACTIVATED_TABS,
          isLoggedIn,
          onLoadMoreClickHandler: onLoadMoreClickHandler(OFFER_TABLE_EVENTS),
          onOfferRowTabClickHandler: onOfferRowTabClickHandler(OFFER_TABLE_EVENTS),
          onTermFilterChangeHandler: onTermFilterChangeHandler(OFFER_TABLE_EVENTS),
          onCountryFilterChangeHandler: onCountryFilterChangeHandler(OFFER_TABLE_EVENTS),
          onInvestmentAmountInputChangeHandler:
            onInvestmentAmountInputChangeHandler(OFFER_TABLE_EVENTS),
          onColumnSortChangeHandler: onColumnSortChangeHandler(OFFER_TABLE_EVENTS),
          onCountryRatingChangeHandler: onCountryRatingChangeHandler(OFFER_TABLE_EVENTS),
          onCTAClickHandler: onCTAClickHandler(OFFER_TABLE_EVENTS),
          isShuffleProductsFeatureFlagOn: isShuffleProductsFeatureFlagOn,
        })}
      />
    </S.WrapperDiv>
  );
};

export default ProductsTabs;
